export default {
  tip1: '1. Currently shows orders placed for self (off site payment) that contain a deposit and can be applied for',
  tip2_prev: '2. The applicable order must meet the following conditions simultaneously',
  tip2: 'Has not applied for, has been returned to the deposit application time;',
  tip3: '3. If all the conditions in the second point have been met and the deposit is no longer applied for, the deposit cannot be applied for, please consult the home service staff',
  exhibition: 'Exhibition',
  exhibition_placeholder: 'Please enter the name of the exhibition',
  remit_code: 'Remittance code',
  remit_code_placeholder: 'Please enter the remittance identification number and enter enter for query',
  remit_code_tip: 'If you pay by cash/credit card on site, please check the remittance identification number',
  foregit_tab: 'Apply for deposit',
  orderNum_label: 'Payment identification code',
  payway_label: 'Pay Way',
  exhibitor: 'Exhibitor',
  exnum: 'Exnum',
  foregift_name: 'Deposit Name',
  amount: 'Amount',
  deduction: 'Deduction amount',
  deduction_name: 'Deduction deposit',
  balance: 'Balance',
  deduction_detail: 'Check the deduction details',
  total: 'Total',
  apply: 'Apply',
  deduction_remark: 'Deduction Remarks',
  warn_tip: 'Tips: click the payment code to view the details of deposit and deduction',
  apply_record: 'Application record',
  modify: 'Modify',
  detail: 'Detail',
  cancel: 'Cancel',
  check_code: 'How do I view the identifier',
  code_prop_1: 'The fees paid on site will be included in the receipt we give you',
  code_prop_2: 'Under bar code',
  code_prop_3: 'See the example in the red box',
  foregift_detail: 'Details of deposit refund application',
  detail_header: 'Basic information of deposit refund application',
  cetification: 'Certification ',
  name: 'Name',
  upload: 'Upload Info',
  remark: 'Remak',
  info_remark: 'Infomation instructions',
  balance_tip: 'Current deposit balance:',
  balance_unit: 'RMB',
  request_num: 'Application number',
  order_num: 'Order number',
  exnum_num: 'Exnum',
  request_time: 'Application Time',
  request_status: 'Application Status',
  operation: 'Operation',
  cancel_title: 'Cancel the deposit application',
  cancel_content: 'Are you sure you want to cancel the deposit application?',
  cancel_ok: 'Yes',
  cancel_deny: 'No',
  // 押金申请
  apply_title: 'Deposit refund application service',
  status: 'Status',
  channel: 'Refund Channel',
  account_type: 'Bank card account type',
  account_info: 'A corporate account is your corporate account, while a private account is your personal account',
  account_type_placeholder: 'Please fill in your bank account type',
  card_type: 'Card type',
  card_type_placeholder: 'Please fill in the bank card type',
  bank_name: 'Bank branch name',
  bank_name_placeholder: 'e.g.Bank of China Shenzhen Minzhi Sub-branch',
  bank_account: 'Bank account',
  bank_account_placeholder: 'Please fill in the bank account number',
  bank_account_name: 'Bank account name',
  bank_account_name_placeholder: 'Please fill in the bank account name',
  city: 'City',
  city_placeholder: 'Please fill in the city',
  province: 'Province',
  province_placeholder: 'Please fill in the province',
  remarks: 'Application remark',
  remarks_placeholder: 'Please fill in the application remark',
  please_upload: 'Please upload the following documents',
  return_list: 'Return the deposit application form',
  commit: 'Apply',
  fee_detail: 'Foregift Detail',
  can_balance: 'The refundable deposit balance is',
  back: 'Back',
  upload_btn: 'Upload',
  del_image_content: 'Sure to delete image?',
  del_title: 'Delete confirm',
  del_success: 'Delete image successfully',
  del_fail: 'Failed to delete image',
  notice: 'Notice',
  no_foregift: 'Currently there is no proof of deposit information',
  no_apply: 'Not appied',
  need_confirm: 'Need be confirmed',
  wait_refund: 'Wait refund',
  tomake: 'tomake',
  refund: 'Refunded',
  accepted: 'Bank accepted',
  rejected: 'Rejected',
  wait_review: 'To audit',
  cancelled: 'Cancelled',
  finished: 'Finished',
  refund_fail: 'Failed to refund',
  upload_button: 'Please Choose image',
  warm_tip_1: 'Tips: failed to apply for deposit refund. If you find that the deposit',
  warm_tip_2: 'is inconsistent with the deposit ',
  warm_tip_3: ' submitted last time, please check the application list of returned deposit and check the deduction situation or consult the project department.',
  public_account: 'Public account',
  private_account: "Private account",
  privacy: 'Privacy',
  debit: 'Debit card',
  save: 'Cash card',
  wechat: 'Wechat Refund',
  alipay: 'Alipay Refund',
  net: 'Net silver refund',
  scene: 'Scene Refund',
  public_way: 'Public account refund',
  CLOUDBILL: 'Cloud Bill Refund',
  pay_online: 'E-currency payment',
  pay_cash: 'Cash card',
  pay_balance: 'The balance payment',
  pay_remit: 'Offline remittance',
  pay_mini_wechat: 'Mini program WeChat payment',
  pay_wechat_scan: 'WeChat scan payment',
  pay_alipay_scan: 'Alipay scanning code payment',
  pay_alipay_h5: 'Alipay mobile payment',
  pay_wechat_h5: 'WeChat mobile payment',
  pay_cloud: "Cloud bill payment",
  pay_wechat: 'WeChat',
  pay_alipay: 'Alipay',
  audit_opinion: 'Audit opinion',
  '如您有特殊情况备注': 'If you have special circumstances, please note',
  '暂无扣费信息': 'No deduction information for the time being',

  '预授权30天内自动解冻，预授权金额：': 'The pre-authorization will automatically unfreeze within 30 days, and the pre-authorized amount: ',
  '元': '',
  existWatingAuditDeductions: "The deposit is currently under review, please try again later"

}



// WEBPACK FOOTER //
// ./src/i18n/en-us/foregift.js